"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocaleClassOnBody = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
let localeStringOnBody;
/**
 * Set locale to the <body> tag as a class name
 * @param rawLocale
 * @returns
 */
const setLocaleClassOnBody = (rawLocale) => {
    console.warn("setLocaleClassOnBody() is deprecated");
    const locale = (rawLocale || "").replace(/-/, "_");
    const regExString = `/${locale}/`;
    const reg = new RegExp(regExString);
    if (typeof window_or_global_1.default.document.body !== "undefined" &&
        typeof window_or_global_1.default.document.body.className !== "undefined" &&
        !reg.test(window_or_global_1.default.document.body.className)) {
        if (localeStringOnBody && locale !== localeStringOnBody) {
            //remove the previous locale
            window_or_global_1.default.document.body.className = window_or_global_1.default.document.body.className
                .replace(localeStringOnBody, "")
                .replace(/[\s]+/g, " ");
            localeStringOnBody = locale;
            if (window_or_global_1.default.document.body.className.length) {
                window_or_global_1.default.document.body.className += ` ${locale}`;
            }
            else {
                window_or_global_1.default.document.body.className += locale;
            }
        }
        else if (localeStringOnBody && locale === localeStringOnBody) {
            //current string is fine
        }
        else {
            localeStringOnBody = locale;
            if (window_or_global_1.default.document.body.className.length) {
                window_or_global_1.default.document.body.className += ` ${locale}`;
            }
            else {
                window_or_global_1.default.document.body.className += locale;
            }
        }
    }
};
exports.setLocaleClassOnBody = setLocaleClassOnBody;
//# sourceMappingURL=bodyUtils.js.map